import React, { Component } from 'react';
import _ from 'lodash';

import UrlHelper from '../../url-helper';
import ReportHelper from '../../report-helper';
import StatusHelper from '../../status-helper';

import { Container, Header, Message } from 'semantic-ui-react';

import GraphsSection from './Sections/Graphs';
import ESLintSection from './Sections/ESLint';
import DependencyUpgradesSection from './Sections/DependencyUpgrades';
import UnitTestSection from './Sections/UnitTest';
import ProblemsSection from './Sections/Problems';
import DetailsSection from './Sections/Details';
import SecuritySection from './Sections/Security';


class PackageView extends Component {
    componentDidMount()
    {
        const opts = UrlHelper.getLocalSearchParams( this.props.location.search ),
            params = this.props.match.params;

        this.props.updatePackageView(
            params.packageName,
            opts.type,
            opts.channel,
            opts.signature
        );
    }


    componentDidUpdate( prevProps )
    {
        if(
            ( prevProps.location.pathname !== this.props.location.pathname ) ||
            ( prevProps.location.search !== this.props.location.search )
        )
        {
            const opts = UrlHelper.getLocalSearchParams( this.props.location.search );

            this.props.updatePackageView(
                this.props.match.params.packageName,
                opts.type,
                opts.channel,
                opts.signature
            );
        }
    }


    componentWillReceiveProps( nextProps )
    {
        this.setState(
            () => {
                return { reportHelper : new ReportHelper( nextProps.pkg.latest, nextProps.pkg.history ) };
            }
        );
    }


    viewPackage( packageName )
    {
        this.props.history.push(
            UrlHelper.getPackageViewUrl( packageName )
        );
    }


    listPackages()
    {
        this.props.history.push(
            UrlHelper.getPackageListUrl()
        );
    }


    resolveStatus( report )
    {
        if( report.state !== 'generated' )
        {
            return report.state;
        }

        return report.data.info.summary.status;
    }


    getMessage( report, status, expand = false )
    {
        if( expand )
        {
            return (
                <Message
                    error={( ( status === 'error' ) || ( status === 'failure' ) )}
                    warning={( status === 'warning' )}
                    success={( status === 'ok' )}
                    size={'large'}
                    icon={StatusHelper.getStatusIconName( status )}
                >
                    <Message.Header>
                        {report.data.info.summary.message}
                    </Message.Header>

                    <Message.Content>
                        {report.data.info.summary.stderr && <pre><code>{report.data.info.summary.stderr}</code></pre>}
                        {report.data.info.summary.stdout && <pre><code>{report.data.info.summary.stdout}</code></pre>}
                    </Message.Content>
                </Message>
            );
        }


        return (
            <Message
                error={( ( status === 'error' ) || ( status === 'failure' ) )}
                warning={( status === 'warning' )}
                success={( status === 'ok' )}
                size={'large'}
                icon={StatusHelper.getStatusIconName( status )}
                content={report.data.info.summary.message}
            />
        );
    }


    getFailureReport( report, status )
    {
        return (
             <Container className='PackageReport' textAlign='left'>
                <Header size={'huge'}>
                    <Header.Content><a href={UrlHelper.getBitbucketRepoUrl( report )} target='_blank'>{report.data.pkg.name}</a></Header.Content>
                    <Header.Subheader>{report.data.pkg.version}</Header.Subheader>
                </Header>

                { report.data.info.summary.message && this.getMessage( report, status, true )}
             </Container>
        );
    }


    getProducedReport( report, status, reportHelper )
    {
        return (
             <Container className='PackageReport' textAlign='left'>
                <Header size={'huge'}>
                    <Header.Content><a href={UrlHelper.getBitbucketRepoUrl( report )} target='_blank'>{report.data.pkg.name}</a></Header.Content>
                    <Header.Subheader>{report.data.pkg.version}</Header.Subheader>
                </Header>

                { report.data.info.summary.message &&
                    <Message
                        error={( status === 'error' )}
                        warning={( status === 'warning' )}
                        success={( status === 'ok' )}
                        size={'large'}
                        icon={StatusHelper.getStatusIconName( status )}
                        content={report.data.info.summary.message}
                    /> }

                <GraphsSection report={report} reportHelper={reportHelper} pkg={this.props.pkg} match={this.props.match} />
                <ProblemsSection report={report} />
                <UnitTestSection report={report} />
                <SecuritySection report={report} />
                <DependencyUpgradesSection report={report} />
                <ESLintSection report={report} />
                <DetailsSection report={report} />

                <Container className='History'>
                </Container>
             </Container>
        );
    }


    render() {
        const report        = _.get( this, 'props.pkg.latest' ),
            reportHelper    = _.get( this, 'state.reportHelper' );

        if( ( !report ) || ( !reportHelper ) )
        {
            return ( <div>Loading...</div> );
        }

        const status = this.resolveStatus( report );

        return (
            <Container className='PackageReport' textAlign='left'>
                { ( status === 'failure' ) && this.getFailureReport( report, status ) }
                { ( status !== 'failure' ) && this.getProducedReport( report, status, reportHelper ) }
            </Container>
        );
    }
}

export default PackageView;




// WEBPACK FOOTER //
// ./src/lib/components/PackageView/PackageView.js